import Image from 'next/image';
import Link from 'next/link';
import Head from "next/head";

export default function Webdesign() {
    const service = {
        title: 'Beratung',
        details: ['Konzepte', 'Strategie', 'Conversion-Optimierung', 'Wordpress', 'Plug Ins', 'Domain & Hosting', 'Schulung & Betreuung'],
        imgSrc: '/serviceImages/pexels-alex-green-5699456.jpg'
    };

    const midIndex = Math.ceil(service.details.length / 2);
    const detailsFirstHalf = service.details.slice(0, midIndex);
    const detailsSecondHalf = service.details.slice(midIndex);

    return (
        <div className="flex flex-col bg-gray-100 p-6 rounded-md  shadow-lg">
            <Head>
                <title>Beratung | deinSEOExpert</title>
                <link rel="icon" href="/favicon.ico"/>
                <meta
                    name="description"
                    content="Erfahren Sie mehr über unsere Beratung-Dienstleistungen. Unsere SEO-Agentur bietet professionelle SEO-Lösungen und kompetente Beratung. Besuchen Sie unsere Website, um Expertenwissen für Ihren SEO-Erfolg zu erhalten."
                />
            </Head>
            <div className="flex flex-col md:flex-row mb-4">
                <div className="relative h-64 md:h-auto md:w-1/2 mb-4 md:mb-0">
                    <Image
                        src={service.imgSrc}
                        alt={service.title}
                        layout="fill"
                        objectFit="cover"
                        objectPosition="center"
                        className="rounded-md"
                    />
                    <h1 className="absolute bottom-0 left-0 p-4 text-xl md:text-2xl font-bold text-white bg-black bg-opacity-40">{service.title}</h1>
                </div>
                <div className="md:w-1/2 flex flex-col md:flex-row md:justify-center md:items-center md:pl-8">
                    <ul className="list-disc list-inside flex-1">
                        {detailsFirstHalf.map((detail, index) => (
                            <li key={index} className="mb-2">{detail}</li>
                        ))}
                    </ul>
                    <ul className="list-disc list-inside flex-1">
                        {detailsSecondHalf.map((detail, index) => (
                            <li key={index} className="mb-2">{detail}</li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="mt-4 text-gray-600 p-6 bg-white rounded-md shadow-lg">
                <div className="mt-4 text-gray-600 p-6 bg-white rounded-md shadow-lg">
                    <p className="mb-4">
                        Als Beratungsexperte biete ich professionelle Dienstleistungen an, um Sie bei der Optimierung Ihres Unternehmens zu unterstützen. Meine Beratungsleistungen umfassen eine Vielzahl von Aspekten, die Ihnen helfen, effektive Strategien zu entwickeln und Ihr Unternehmen erfolgreich zu machen.
                    </p>

                    <p className="mb-4">
                        Ich stehe Ihnen zur Seite, um maßgeschneiderte Konzepte zu entwickeln und eine effektive Strategie zu definieren, die Ihren spezifischen Anforderungen und Zielen entspricht. Durch Conversion-Optimierung und die Implementierung von WordPress und Plug-Ins können wir Ihre Online-Präsenz maximieren und Ihre Zielgruppe besser erreichen.
                    </p>

                    <p className="mb-4">
                        Darüber hinaus biete ich Unterstützung bei der Auswahl von Domain und Hosting, um eine stabile und leistungsfähige Online-Plattform für Ihr Unternehmen zu gewährleisten. Ich stehe Ihnen auch bei der Schulung und Betreuung zur Seite, um sicherzustellen, dass Sie das Beste aus Ihren digitalen Aktivitäten herausholen.
                    </p>

                    <p className="mb-4">
                        Ich bin stolz auf meine Arbeit und kann Ihnen Fallstudien und Beispiele erfolgreicher Beratungsprojekte präsentieren. Mein Ziel ist es, Ihnen einen Einblick in meine Fähigkeiten und Erfahrungen zu geben und Sie bei der Umsetzung Ihrer Unternehmensziele zu unterstützen. Wenn Sie weitere Informationen benötigen oder Fragen haben, stehe ich Ihnen gerne zur Verfügung. Kontaktieren Sie mich noch heute, um mehr über meine Beratungsdienstleistungen zu erfahren und wie ich Ihnen helfen kann, Ihr Unternehmen zu optimieren.
                    </p>
                </div>
            </div>
        </div>
    );
}
